<script setup lang="ts">
type Props = {
  width?: string | number,
  height?: string | number,
  background?: string,
  color?: string,
  borderWidth?: number,
  borderColor?: string,
  padding?: string | number,
};

const props = defineProps<Props>();
</script>
<template>
  <div
    class="flex items-center justify-center rounded-full"
    :class="[typeof props.padding === 'string' ? props.padding : typeof props.padding === 'number' ? `${props.padding}px` : '']"
    :style="{
      width: typeof props.width === 'string' ? props.width : `${props.width}px`,
      height: typeof props.height === 'string' ? props.height : `${props.height}px`,
      backgroundColor: props.background,
      color: props.color,
      border: `${props.borderWidth ?? 1}px solid ${props.borderColor}`
    }"
  >
    <slot />
  </div>
</template>
